import { STORE_CONSTANTS } from '../store/constants/constants';
import CookiesService from '../services/cookies.service';
export function persistDarkMode(isDarkMode) {
    CookiesService.setCookie({ key: STORE_CONSTANTS.DARK_MODE_KEY, value: `${isDarkMode}` });
    document.getElementsByTagName('html')[0].setAttribute('dark-mode', `${isDarkMode}`);
}
